import { VerifyEmailContent } from './VerifyEmailContent';

export default function VerifyEmailPage() {
    return <VerifyEmailContent />;
}
